export default __webpack_public_path__ + "static/media/checkedLW.cc81e213.svg";